import { selectCurrentHotelName } from 'accessors'
import CloseIcon from 'components/ReusableComponents/CloseIcon'
import Dialog from 'components/ReusableComponents/Dialog'
import AnnouncementsIcon from 'components/ReusableComponents/Icons/Announcement'
import ChatIcon from 'components/ReusableComponents/Icons/Chat'
import ChatBotIcon from 'components/ReusableComponents/Icons/ChatBot'
import InviteIcon from 'components/ReusableComponents/Icons/Invite'
import LockOpen from 'components/ReusableComponents/Icons/LockOpen'
import TextBlastIcon from 'components/ReusableComponents/Icons/TextBlast'
import { directfulServiceTypes } from 'main/directfulServices'
import { createContext, useContext, useState } from 'react'
import { useSelector } from 'react-redux'

import styles from './UnlockServiceDialog.module.scss'

const UnlockServiceContext = createContext()

export const services = {
  marketing: 'marketing',
  messaging: 'messaging'
}

export const features = {
  Messaging: 'Messaging',
  SalesMessaging: 'Sales messaging',
  Campaigns: 'Advanced campaigns',
  ChatBotResponses: 'ChatBot responses',
  Announcements: 'Announcements',
  TextBlast: 'Text blast'
}

function getServiceFromFeature(feature) {
  switch (feature) {
    case features.Messaging:
      return services.messaging
    case features.SalesMessaging:
      return services.marketing
    case features.Campaigns:
      return services.marketing
    case features.ChatBotResponses:
      return services.messaging
    case features.Announcements:
      return services.marketing
    case features.TextBlast:
      return services.marketing
    default:
      return null
  }
}

export const UnlockServiceProvider = ({ children }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [feature, setFeature] = useState(null)
  const [service, setService] = useState(null)

  function openDialog(feature) {
    setFeature(feature)
    setService(getServiceFromFeature(feature))
    setIsDialogVisible(true)
  }

  function closeDialog() {
    setIsDialogVisible(false)
  }

  return (
    <UnlockServiceContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      {isDialogVisible && (
        <UnlockServiceDialog
          feature={feature}
          service={service}
          onClose={() => setIsDialogVisible(false)}
        />
      )}
    </UnlockServiceContext.Provider>
  )
}

const UnlockServiceDialog = ({ onClose, feature, service }) => {
  const hotelName = useSelector(selectCurrentHotelName)

  const userName = useSelector(s => s.login.currentUser.name)

  function openChat() {
    window.$crisp.push(['do', 'chat:open'])
    window.$crisp.push([
      'set',
      'message:text',
      [`I want to unlock ${service} service for ${hotelName}`]
    ])
    onClose()
  }

  return (
    <Dialog>
      <div className={styles.dialog}>
        <div className={styles.header}>
          <button>
            <CloseIcon onClick={onClose} className={styles.closeIcon} />
          </button>
        </div>
        <div className={styles.content}>
          {feature === features.Messaging && (
            <div className={styles.iconHolder}>
              <ChatIcon />
            </div>
          )}
          {feature === features.SalesMessaging && (
            <div className={styles.iconHolder}>
              <ChatIcon />
            </div>
          )}
          {feature === features.Campaigns && (
            <div className={styles.iconHolder}>
              <InviteIcon />
            </div>
          )}
          {feature === features.ChatBotResponses && (
            <div className={styles.iconHolder}>
              <ChatBotIcon />
            </div>
          )}
          {feature === features.Announcements && (
            <div className={styles.iconHolder}>
              <AnnouncementsIcon />
            </div>
          )}
          {feature === features.TextBlast && (
            <div className={styles.iconHolder}>
              <TextBlastIcon />
            </div>
          )}
          {/* <p className={styles.featureName}>{feature}</p> */}
          {feature === features.ChatBotResponses && (
            <>
              {/* <p className={styles.title}>
                Automatically respond to common guest questions
              </p> */}
              <p className={styles.mainText}>
                Hello {userName}, we're excited to introduce our new In-Property Messaging
                Package designed to enhance your guests' experience during their stay at
                your hotel. With this package, you can provide superior communication and
                personalized service at every touchpoint. However, it's currently not
                included in your plan. To unlock these powerful tools and create
                unforgettable guest experiences, simply click the 'Unlock' button below.
                Your dedicated account manager will be there to guide you through the
                seamless setup process. Thank you for being a valued partner in delivering
                exceptional hospitality.
              </p>
            </>
          )}
          {feature === features.Messaging && (
            <>
              {/* <p className={styles.title}>Chat with your guests</p> */}
              <p className={styles.mainText}>
                Hello {userName}, We're excited to introduce our new In-Property Messaging
                Package designed to enhance your guests' experience during their stay at
                your hotel. With this package, you can provide superior communication and
                personalized service at every touchpoint. However, it's currently not
                included in your plan. To unlock these powerful tools and create
                unforgettable guest experiences, simply click the 'Unlock' button below.
                Your dedicated account manager will be there to guide you through the
                seamless setup process. Thank you for being a valued partner in delivering
                exceptional hospitality.
              </p>
            </>
          )}
          {feature === features.SalesMessaging && (
            <>
              {/* <p className={styles.title}>Reach guests at the right time</p> */}
              <p className={styles.mainText}>
                Hello {userName}, great news! Our marketing package is designed to boost
                your revenue by leveraging powerful features tailored for your success.
                However, it's currently not included in your plan. To unlock these
                revenue-driving tools, simply click the 'Unlock' button below and your
                dedicated account manager will guide you through the process. Thank you
                for being a valued customer!
              </p>
            </>
          )}
          {feature === features.Campaigns && (
            <>
              {/* <p className={styles.title}>Reach guests at the right time</p> */}
              <p className={styles.mainText}>
                Hello {userName}, great news! Our marketing package is designed to boost
                your revenue by leveraging powerful features tailored for your success.
                However, it's currently not included in your plan. To unlock these
                revenue-driving tools, simply click the 'Unlock' button below and your
                dedicated account manager will guide you through the process. Thank you
                for being a valued customer!
              </p>
            </>
          )}
          {feature === features.Announcements && (
            <>
              {/* <p className={styles.title}>Send announcements to your guests</p> */}
              <p className={styles.mainText}>
                Hello {userName}, great news! Our marketing package is designed to boost
                your revenue by leveraging powerful features tailored for your success.
                However, it's currently not included in your plan. To unlock these
                revenue-driving tools, simply click the 'Unlock' button below and your
                dedicated account manager will guide you through the process. Thank you
                for being a valued customer!
              </p>
            </>
          )}
          {feature === features.TextBlast && (
            <>
              {/* <p className={styles.title}>Send text messages to your guests</p> */}
              <p className={styles.mainText}>
                Hello {userName}, great news! Our marketing package is designed to boost
                your revenue by leveraging powerful features tailored for your success.
                However, it's currently not included in your plan. To unlock these
                revenue-driving tools, simply click the 'Unlock' button below and your
                dedicated account manager will guide you through the process. Thank you
                for being a valued customer!
              </p>
            </>
          )}
          <button className={styles.unlockButton} onClick={() => openChat()}>
            <LockOpen />
            <span className={styles.buttonText}>Unlock {service} service</span>
          </button>
        </div>
      </div>
    </Dialog>
  )
}

export const useUnlockService = () => {
  const services = useSelector(s => s.login.activeServices)

  const isPaused = useSelector(s => s.hotelDetails.status === 'Paused')

  const { openDialog: openUnlockServiceDialog, closeDialog: closeUnlockServiceDialog } =
    useContext(UnlockServiceContext)

  const hasMarketingService =
    services.includes(directfulServiceTypes.Marketing) ||
    services.includes(directfulServiceTypes.MarketingWithCommission)

  const hasMessagingService = services.includes(directfulServiceTypes.Messaging)

  return {
    openUnlockServiceDialog,
    closeUnlockServiceDialog,
    services,
    hasMarketingService,
    hasMessagingService,
    isPaused
  }
}

export default UnlockServiceDialog
